import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import LoginPage from "../LoginPage/LoginPage";

function App() {
  return (
    <>
      <LoginPage />
    </>
  );
}

export default App;

//  eventual login validation
//       {loggedIn ? <Redirect to="/dashboard" /> : <LoginPage />}
